import { CommunicationPreference } from "../../../__generated__/types";
import { StepFormContainer } from "../../../components/step-form";
import { HdgCheckboxGroup } from "../../../components/hdg-checkbox-group";
import { DmaSearch } from "../../../components/dma-search";
import { Chip, Stack } from "@mui/material";
import "./styles.scss";
import { DmaMap } from "../../../components/dma-map";
import { StepBars } from "../../../components/step-bars";

export const TerritorySelectionFieldset = ({
  isValid,
  step,
  setNextStep,
  setStep,
  setWorkLocation,
  setCommunicationPreference,
  workLocation,
  communicationPreference = [],
  setLoading,
}: {
  isValid: boolean;
  step: number;
  setNextStep: () => void;
  setStep: (value: number) => void;
  setWorkLocation: (value: string[]) => void;
  setCommunicationPreference: (value: CommunicationPreference[]) => void;
  workLocation?: string[];
  communicationPreference?: CommunicationPreference[];
  setLoading: (value: boolean) => void;
}) => {
  return (
    <StepFormContainer
      step={5}
      visible={step === 5}
      isValid={isValid}
      onSubmit={() => {
        setNextStep();
      }}
      onBack={() => setStep(4)}
    >
      <StepBars
        stepCount={3}
        currentStep={3}
        title="Account Preferences"
      />
      <p className="font-size-4">
        <b>Where do you want to work?</b>
      </p>
      <p className="font-size-4">Pick as many or as few as you like.</p>

      <DmaMap
        onRemove={(dma) => {
          const dmaValue = dma?.toString();
          setWorkLocation(workLocation?.filter((wl) => wl !== dmaValue) ?? []);
        }}
        onSelect={(dma) => {
          const dmaValue = dma?.toString();
          if (!workLocation?.includes(dmaValue)) {
            setWorkLocation([...(workLocation || []), dmaValue?.toString()]);
          }
        }}
        selection={workLocation}
      />
      <p className="font-size-3">
        We'll automatically include a default territory in your membership when
        you select multiple territories. You can manage your assigned
        territories later. Each additional territory will add to your cost.
      </p>

      <b className="font-size-4">Communication Preferences:</b>
      <HdgCheckboxGroup<CommunicationPreference>
        value={communicationPreference}
        onChange={setCommunicationPreference}
        options={Object.values(CommunicationPreference)}
      />
    </StepFormContainer>
  );
};
